<div class="back-link">
  <a mat-button routerLink="/sammelmappen">
    <mat-icon>arrow_back</mat-icon>
    Alle Sammelmappen
  </a>
</div>

@if (loadError) {
  <div class="mat-elevation message-box">
    <mat-icon class="gray">folder_off</mat-icon>
    <p>{{ loadError }}</p>
    <a color="primary" mat-flat-button routerLink="/sammelmappen">Zur Übersicht</a>
  </div>
} @else if (!folder) {
  <div class="center-content pad16">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
} @else {
  <div class="headline">
    <div class="title">
      <span class="mat-h1 m0">{{ folder.name }}</span>
      <span class="gray meta">
        @if (isOwner) {
          Eigene Sammelmappe
        } @else {
          Von {{ folderUserName(folder.owner) }} · Berechtigung: {{ accessLabels[folder.access] }}
        }
        · {{ folder.itemCount }}/{{ maxItems }} Einträge
        · geändert {{ folder.updatedAt | date: 'dd.MM.yyyy HH:mm' }}
      </span>
    </div>
    <div class="actions">
      @if (canEdit) {
        <button (click)="rename()" mat-stroked-button>
          <mat-icon>edit</mat-icon>
          Umbenennen
        </button>
      }
      <button (click)="duplicate()" mat-stroked-button>
        <mat-icon>content_copy</mat-icon>
        Duplizieren
      </button>
      <button (click)="export()" color="accent" mat-flat-button>
        <mat-icon>download</mat-icon>
        Exportieren
      </button>
      @if (isOwner) {
        <button (click)="share()" color="primary" mat-flat-button>
          <mat-icon>share</mat-icon>
          Teilen
        </button>
        <button (click)="delete()" aria-label="Sammelmappe löschen" color="warn" mat-icon-button
                matTooltip="Sammelmappe löschen">
          <mat-icon>delete</mat-icon>
        </button>
      } @else if (!folder.pending) {
        <button (click)="leave()" aria-label="Aus meinen Sammelmappen entfernen" color="warn" mat-icon-button
                matTooltip="Aus meinen Sammelmappen entfernen">
          <mat-icon>folder_off</mat-icon>
        </button>
      }
    </div>
  </div>
  <hr>

  @if (folder.pending) {
    <div class="pending-banner mat-elevation">
      <mat-icon class="pending-icon">mark_email_unread</mat-icon>
      <span class="pending-text">
        {{ folderUserName(folder.owner) }} hat diese Sammelmappe mit Ihnen geteilt
        ({{ accessLabels[folder.access] }}). Möchten Sie sie annehmen?
      </span>
      <span class="pending-actions">
        <button (click)="leave()" mat-stroked-button>Ablehnen</button>
        <button (click)="accept()" color="primary" mat-flat-button>Annehmen</button>
      </span>
    </div>
  }

  @if (canEdit && selectedItems.length > 0) {
    <div class="selection-bar mat-elevation">
      <span>{{ selectedItems.length }} {{ selectedItems.length === 1 ? 'Eintrag' : 'Einträge' }} ausgewählt</span>
      <span class="selection-actions">
        <button (click)="clearSelection()" mat-button>Auswahl aufheben</button>
        <button (click)="copySelectedToFolder()" mat-stroked-button>
          <mat-icon>drive_file_move</mat-icon>
          Zu anderer Sammelmappe hinzufügen
        </button>
        <button (click)="removeSelected()" color="warn" mat-flat-button>
          <mat-icon>playlist_remove</mat-icon>
          Aus Sammelmappe entfernen
        </button>
      </span>
    </div>
  }

  <div [class.reloading]="loading" class="sections">
    @for (section of sections; track section.type) {
      <mat-expansion-panel [expanded]="true" class="section">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ section.label }}</mat-panel-title>
          <mat-panel-description>
            {{ folder[section.list].length }} {{ folder[section.list].length === 1 ? 'Eintrag' : 'Einträge' }}
          </mat-panel-description>
        </mat-expansion-panel-header>
        <app-folder-entry-table [entries]="folder[section.list]" [selectable]="canEdit"
                                (entryEdited)="load()"
                                [selection]="selection.get(section.type)"
                                [typeInfo]="section"></app-folder-entry-table>
      </mat-expansion-panel>
    } @empty {
      <div class="mat-elevation message-box">
        <mat-icon class="gray">folder_open</mat-icon>
        <p>Diese Sammelmappe ist leer.</p>
        @if (canEdit) {
          <p class="gray">
            Wählen Sie in den Tabellen von Wortschatz, Grammatik, Kannbeschreibungen, Sprachhandlungen,
            Textsorten oder Textmustern Einträge aus und fügen Sie sie über „Zu Sammelmappe hinzufügen“ hinzu.
          </p>
        }
      </div>
    }
  </div>
}
